import React from 'react';
import Layout from './Layout';

interface ServiceLayoutProps {
  /**
   * Page content
   */
  children: React.ReactNode;
  /**
   * Optional additional CSS classes
   */
  className?: string;
  /**
   * Show related services section
   */
  showRelatedServices?: boolean;
  /**
   * Show CTA section
   */
  showCTA?: boolean;
}

/**
 * Layout component specifically for service pages with consistent structure
 */
const ServiceLayout: React.FC<ServiceLayoutProps> = ({
  children,
  className = '',
  showRelatedServices = true,
  showCTA = true,
}) => {
  return (
    <Layout>
      <div className={className}>
        {children}
      </div>
    </Layout>
  );
};

export default ServiceLayout;